// Trade Operations: the routes and the sidebar rows of `wealth.ops.trade-operations` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.ops.trade-operations',
    routes: [
        {
            frontend: 'ops',
            path: 'trade-operations',
            lazy: () => import('@/pages/ops/trade-operations/page'),
        },
    ],
    nav: [
        // Retired from the Ops view pending a PMS source. The blotter cannot be
        // useful until a trade-settlement system feeds it, so the row is hidden
        // rather than shown against nothing. Drop the flag when the PMS lands.
        {
            frontend: 'ops',
            key: 'trade-operations',
            label: 'Trade Operations',
            href: '/ops/trade-operations',
            icon: 'ArrowRightLeft',
            group: 'processing',
            order: 2050,
            hidden: true,
        },
    ],
});
